/* eslint-disable react/no-danger */
import Popper from '@mui/material/Popper'
import Fade from '@mui/material/Fade'
import cx from 'classnames'

import { highlightTextV2 } from '../../../../../../../../../utils/highlight-text'
import Spinner from '../../../../../../../../Spinner'

import useStyles from './style'

const AvailableItemsPopper = ({
  open,
  setOpen,
  id,
  anchorEl,
  dropdownRef,
  setSearchPhrase,
  isAvailableListFetching,
  searchPhrase,
  items = [],
  addNewItem = () => {},
}) => {
  const classes = useStyles()

  return (
    <Popper
      id={id}
      open={open}
      anchorEl={anchorEl}
      style={{
        zIndex: 111111,
      }}
      transition
      placement="bottom-start"
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <div className={classes.dropdown} ref={dropdownRef}>
            <div className={classes.dropdown_inner}>
              {isAvailableListFetching && (
                <div className={classes.item}>
                  <Spinner />
                </div>
              )}
              {!isAvailableListFetching &&
                items.map((item) => (
                  <div className={classes.item} key={item.categoryID}>
                    <div
                      className={classes.text}
                      dangerouslySetInnerHTML={{
                        __html: highlightTextV2(item.searchPhrase, searchPhrase),
                      }}
                    />
                    <button
                      className={classes.add_button}
                      type="button"
                      onClick={() => {
                        addNewItem(item)
                        setOpen(false)
                        setSearchPhrase('')
                      }}
                    >
                      +
                    </button>
                  </div>
                ))}
              {!isAvailableListFetching && !items.length && (
                <div className={classes.item}>
                  <span className={cx(classes.text, classes.center)}>Sorry, no result found.</span>
                </div>
              )}
            </div>
          </div>
        </Fade>
      )}
    </Popper>
  )
}

export default AvailableItemsPopper
